import { render } from "./approvalMailEquipments.vue?vue&type=template&id=7da2196c&scoped=true&ts=true"
import script from "./approvalMailEquipments.vue?vue&type=script&lang=ts"
export * from "./approvalMailEquipments.vue?vue&type=script&lang=ts"

import "./approvalMailEquipments.vue?vue&type=style&index=0&id=7da2196c&scoped=true&lang=css"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7da2196c"]])

export default __exports__